import { ASNPost, Filtro } from '../interfaces/Asn';
import { getUrlAsnApi } from '../utils/util';
import ApiHandler from './ApiHandler';

export const baseURL = String(getUrlAsnApi(window));

export default class AsnApi {
    static async search(filtro: Filtro) {

        const params = new URLSearchParams();
        params.append('asnId', filtro.AsnId?.toString()??"");
        params.append('asnNumber', filtro.AsnNumber || '');
        params.append('shippingCompanySupplierCorporateName', filtro.ShippingCompanySupplierCorporateName || '');
        params.append('invoiceKey', filtro.InvoiceKey || '');
        params.append('submitDateStart', filtro.SubmitDateStart ||'');
        params.append('submitDateEnd', filtro.SubmitDateEnd || '');
        params.append('status', filtro.Status || '');
        params.append('PlateNumber', filtro.PlateNumber || '');
        params.append('pageIndex', filtro.pageIndex.toString());
        params.append('pageSize', filtro.pageSize.toString());
        params.append('Discriminator', filtro.Discriminator || '');

        var response = await ApiHandler(baseURL).get('asn/search', { params });

        return response.data;
    }
    static async postAsn(data: ASNPost) {
        var response = await ApiHandler(baseURL).post('asn', data);
        return response;
    }

    static async putAsn(data: ASNPost) {
        var response = await ApiHandler(baseURL).put('asn', data);
        return response;
    }

    // static async changeAsnStatus(asnId: number, status: string) {
    //     var response = await ApiHandler(baseURL).put('asn/change-status', {id: asnId, status: status});
    //     return response;
    // }

    static async cancelAsn(asnId: number) {
        var response = await ApiHandler(baseURL).put(`asn/cancel/${asnId}`);
        return response;
    }

    static async receiptAsn(asnId: number) {
        var response = await ApiHandler(baseURL).put(`asn/receipt/${asnId}`);
        return response;
    }


    static async SubmitAsn(data: any) {
        var response = await ApiHandler(baseURL).put('asn/issue', data);
        return response;
    }

    static async validateInvoicesInUse(asnId: number, invoiceKey: string) {
        var response = await ApiHandler(baseURL).get(`asn/validate-invoice?asnId=${asnId}&invoiceKey=${invoiceKey}`);
        return response.data;
    }

    
    static async validateRemitoInUse(asnId: number, remitoNumber: string, exportInvoice: string) {
        var response = await ApiHandler(baseURL).get(`asn/validate-remito?asnId=${asnId}&remitoNumber=${remitoNumber}&exportationInvoice=${exportInvoice}`);
        return response.data;
        //return "";
    }

}


